module.exports = __webpack_public_path__ + "static/media/w.c94b7725.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/w.mp3
// module id = 112
// module chunks = 0